import angular from 'angular';
import adminpulse from '@/shared/utils/adminpulse';

angular
  .module('cxInvoicing')
  .controller('MergeInvoicesDialogCtrl', [
    '$element',
    'close',
    'invoice',
    'appUrls',
    '$http',
    '$timeout',
    'flySvc',
    'dataCache',
    'checkFeature',
    mergeInvoicesDialogCtrl,
  ]);

function mergeInvoicesDialogCtrl(
  $element,
  close,
  invoice,
  appUrls,
  $http,
  $timeout,
  flySvc,
  dataCache,
  checkFeature,
) {
  var vm = this;
  vm.relation = invoice.customer;
  vm.mainInvoiceId = invoice.id;
  vm.showAssignments = dataCache.getArray('assignmentsEnabled');
  vm.showReferenceYear = checkFeature('ReferenceYear');

  vm.invoices = [];

  vm.loading = true;
  $http
    .get(`${appUrls.api}/Api/DraftInvoice/DraftInvoices`, {
      params: {
        locked: false,
        hasDateToNumber: false,
        relationId: invoice.customer.id,
        ownCompanies: [invoice.companyId],
        invoiceType: [1, 2, 3, 4, 5],
      },
    })
    .then(
      ({ data }) => {
        vm.loading = false;
        vm.invoices = data.map(x => ({ ...x, selected: x.id === vm.mainInvoiceId }));
      },
      error => {
        vm.loading = false;
        flySvc.error(error);
      },
    );
  vm.mainInvoiceChanged = function() {
    if (!vm.mainInvoiceId) return;
    const invoice = vm.invoices.find(x => x.id === vm.mainInvoiceId);
    invoice.selected = true;
  };

  vm.isValid = function() {
    if (!vm.mainInvoiceId) return false;
    const selectedInvoices = vm.invoices.filter(x => x.selected).map(x => x.id);
    if (selectedInvoices.length <= 1) return false;
    return true;
  };
  vm.save = function() {
    if (!vm.mainInvoiceId) return;
    const selectedInvoices = vm.invoices.filter(x => x.selected).map(x => x.id);
    if (selectedInvoices.length <= 1) return;

    vm.saving = true;
    $http
      .post(`${appUrls.api}/Api/DraftInvoice/Merge`, {
        mainInvoiceId: vm.mainInvoiceId,
        invoices: selectedInvoices,
      })
      .then(
        () => {
          vm.saving = false;
          flySvc.success();
          $element.modal('hide');
          close(true, 500);
        },
        error => {
          vm.saving = false;
          flySvc.error(error);
        },
      );
  };

  vm.cancel = function() {
    close(null, 500);
  };
}
